import { render, staticRenderFns } from "./AddEmployeeTimeoffComponent.vue?vue&type=template&id=488f33ea&"
import script from "./AddEmployeeTimeoffComponent.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeTimeoffComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports